<template>
  <div class="template">
    <div
      class="title-area"
      :style="{ backgroundImage: `url(${bannerlis.img ==undefined?'': domain + bannerlis.img})` }"
    >
      <div class="wrap">
        <div class="top-wrap">
          <div class="title">
            <slot name="title"></slot>
          </div>
          <span class="english-title">
            <slot name="english-title"></slot>
          </span>
        </div>
      </div>
    </div>
    <div class="crumb">
      <div class="wrap">
        <slot name="crumb"></slot>
      </div>
    </div>
    <div class="content-area">
      <div class="item">
        <div class="device">
          <slot name="device"></slot>
        </div>
        <div class="special">
          <div class="caption">产品特点</div>
          <div class="info wrap2">
            <slot name="other"></slot>
            <!-- <div class="special-item">
              <div class="title">
                <slot name="sp1"></slot>
              </div>
              <div class="info">
                <slot name="sp1-info"></slot>
              </div>
            </div>
            <div class="special-item">
              <div class="title">
                <slot name="sp2"></slot>
              </div>
              <div class="info">
                <slot name="sp2-info"></slot>
              </div>
            </div>
            <div class="special-item">
              <div class="title">
                <slot name="sp3"></slot>
              </div>
              <div class="info">
                <slot name="sp3-info"></slot>
              </div>
            </div>
            <div class="special-item">
              <div class="title">
                <slot name="sp4"></slot>
              </div>
              <div class="info">
                <slot name="sp4-info"></slot>
              </div>
            </div>
            <div class="special-item">
              <div class="title">
                <slot name="sp5"></slot>
              </div>
              <div class="info">
                <slot name="sp5-info"></slot>
              </div>
            </div> -->
          </div>
          <slot name="custom"></slot>
        </div>
        <div class="env">
          <div class="caption">应用场景</div>
          <div class="info">
            <div class="info-w" :style="{ left: left + 'px' }">
              <div class="info-wrap" ref="env">
                <div class="env-item" v-for="(item, idx) in imgList" :key="idx"  >
                  <div class="top-img">
                    <img :src="domain + item.scenarios_img" alt="" @load="imgload(1)"/>
                  </div>
                  <div class="text">{{ item.title }}</div>
                </div>
              </div>
              <div class="info-wrap">
                <div class="env-item" v-for="(item, idx) in imgList" :key="idx">
                  <div class="top-img">
                    <img :src="domain + item.scenarios_img" alt="" @load="imgload(1)"/>
                  </div>
                  <div class="text">{{ item.title }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <Footer />
    </div>
    <div class="black" v-show="isShowForm">
      <div class="black-conten">
        <div class="title">产品咨询</div>
        <div class="close-btn" @click="closeForm()">
          <img src="../assets/img/icon/icon_gb@2x.png" alt="" />
        </div>
        <el-form
          label-position="right"
          label-width="120px"
          :model="formLabelAlign"
          :rules="rules"
        >
          <el-form-item label="单位名称" prop="date1">
            <el-input
              v-model="formLabelAlign.name"
              placeholder="请输入单位名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="date2">
            <el-input
              v-model="formLabelAlign.region"
              placeholder="请输入联系人"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="type">
            <el-input
              v-model="formLabelAlign.type"
              placeholder="联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="需求描述">
            <el-input
              type="textarea"
              placeholder="请输入"
              v-model="formLabelAlign.type2"
              resize="none"
              :rows="4"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div class="submit" @click="submitForm()">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "./footer.vue";
import { banner, submit, product2 } from "../network/http_api";
import { BASEDOMAIN } from "../common/config";

export default {
  props: {
    isShow: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loadCount:0,
      domain: "",
      bannerlis: {},

      isShowForm: false,
      left: 0,
      timer: null,
      ele_width: 0,
      imgList: [],
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
        type2: "",
      },
      rules: {
        date1: [{ message: "请输入单位名称", trigger: "blur" }],
        date2: [{ message: "请输入联系人姓名", trigger: "blur" }],
        type: [{ message: "请输入联系电话", trigger: "blur" }],
      },
    };
  },
  components: {
    Footer,
  },
  watch: {
    isShow(val) {
      this.isShowForm = true;
    },
  },
  mounted() {
    this.domain = BASEDOMAIN;
    //console.log("banner123");
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
    });
    this.getBanner();

    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
    });
    // let f = this.$refs.env;
    
    // //console.log('f',f.offsetWidth);
    this.getEnv();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    imgload(c){
      this.loadCount ++
      if(this.loadCount == this.imgList.length *2){
      //console.log('loaddd');
      this.$nextTick(() => {
      this.ele_width = this.$refs.env.offsetWidth;
      this.move();
    });
      }else {
        //console.log('this.imgList.length *2',this.imgList.length *2);
      }
    },
    async getEnv() {
      let res = await product2(2);
      if (res.code == 200) {
        this.imgList = res.data;
      } else {
        this.$message.error(res.msg);
      }
      //console.log("product2", res);
    },
    async sbm() {
      let res = await submit(
        this.formLabelAlign.name,
        this.formLabelAlign.region,
        this.formLabelAlign.type,
        this.formLabelAlign.type2
      );
      if (res.code == 200) {
        this.isShowForm = false;

        this.formLabelAlign = {
          name: "",
          region: "",
          type: "",
          type2: "",
        };
        this.$message({
          message: res.msg,
          type: "success",
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    async getBanner() {
      let res = await banner(3);
      if (res.code == 200) {
        this.bannerlis = res.data[0];
      } else {
        this.$message.error(res.msg);
      }
      //console.log("banner", res);
    },
    move() {
      this.timer = setInterval(() => {
        if (this.left < -this.ele_width) {
          this.left = 0;
          //console.log(this.left, -this.ele_width);
        }
        this.left -= 0.5;
      }, 16);
    },
    closeForm() {
      this.isShowForm = false;
      this.formLabelAlign = {
        name: "",
        region: "",
        type: "",
        type2: "",
      };
    },
    submitForm() {
      this.sbm();
    },
  },
};
</script>

<style lang='scss' scoped>
::v-deep .el-form-item__label {
  font-size: 16px !important;
  color: #000;
}
::v-deep .el-input {
  width: 320px !important;
}
::v-deep .el-textarea__inner {
  font-size: 16px;
}
::v-deep .el-textarea {
  width: 320px !important;
}
.black {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  .black-conten {
    position: relative;
    width: 506px;
    padding: 0 60px;
    background: #fff;
    margin: 0 auto;
    margin-top: 100px;
    .close-btn {
      position: absolute;
      top: 22px;
      right: 22px;
      width: 24px;
      height: 24px;
      img {
        width: 100%;
      }
      cursor: pointer;
    }
    .title {
      font-size: 20px;
      font-weight: 600;
      color: #000000;
      padding: 41px 0 53px;
      text-align: center;
    }
    .submit {
      display: inline-block;
      padding: 7px 45px;
      color: #fff;
      font-size: 15px;
      background: #1d7bff;
      margin-left: 50%;
      transform: translateX(-50%);
      margin-top: 50px;
      margin-bottom: 46px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}

.template {
  // margin-top: 64px;
  background: #f5f5f5;
  .wrap {
    width: 1240px;
    margin: 0 auto;
  }
  .wrap2 {
    width: 1200px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
  .title-area {
    height: 450px;
    background: url("") no-repeat;
    background-size: cover;
    overflow: hidden;
    .top-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 150px;
    }
    .title {
      font-size: 64px;
      font-weight: 600;
      color: #ffffff;
      line-height: 75px;
      margin-bottom: 25px;
    }
    .english-title {
      font-size: 32px;
      font-weight: 400;
      color: #ffffff;
      line-height: 38px;
    }
  }
  .crumb {
    margin-top: 32px;
  }
  .content-area {
    margin-bottom: 97px;
    .item {
      .special {
        background: #fff;
        padding-bottom: 70px;
        .special-item {
          margin-bottom: 26px;
          .title {
            font-size: 22px;
            font-weight: 600;
            color: #202020;
            line-height: 26px;
            margin-bottom: 10px;
          }
          .info {
            font-weight: 400;
            color: #606266;
            line-height: 19px;
          }
        }
      }
      .env {
        padding: 0 115px;
        .info {
          width: 1170px;
          overflow: hidden;
          margin-left: 50%;
          transform: translateX(-50%);
        }
        .info-w {
          position: relative;
          left: 0;
          display: flex;
        }
        .info-wrap {
          display: flex;
        }
        .env-item {
          background: #fff;
          width: 220px;
          margin-right: 14px;
          .top-img {
            height: 200px;
          }
          .text {
            padding: 16px 29px 17px 29px;
            font-size: 18px;
            font-weight: 400;
            text-align: center;
          }
        }
      }

      .caption {
        display: inline-block;
        font-size: 24px;
        font-weight: 600;
        color: #202020;
        padding: 8px 17px;
        margin: 42px 0 42px 50%;
        transform: translateX(-50%);
        border-bottom: 4px solid #1d7bff;
        letter-spacing: 2px;
      }
      .info {
        color: #606266;
        img {
          width: 100%;
        }
      }
      .detail {
        color: #606266;
      }
    }
  }
}
</style>